import React, { useCallback } from "react";
import {
  ButtonPrimary,
  Headline,
  JsonData,
  SectionContent,
  Text,
} from "../../../../components";
import { endpoints } from "../../../../config";
import { useAjaxRequest } from "../../../../hooks";
import { SampleRequestResult } from "./SampleRequest.Style";

const SampleRequest = () => {
  const { response, error, loading, performRequest } = useAjaxRequest();

  const handleRequest = useCallback(() => {
    const options = {
      url: endpoints.getResultadoSorteiosEndPoint({ plano: { value: 223.1 } }),
    };
    performRequest(options);
  }, [performRequest]);

  return (
    <SectionContent>
      <Headline nivel="2" styleAs="5" text="Request APIC" />
      <Text>
        Requisição ao resultado de sorteio de capitalização. caso as informações
        para aparece na tela o resultado a variavel de ambiente
        <pre>
          <code>REACT_APP_ENABLE_DEBUG_DATA=true</code>
        </pre>
        deve estar configurada devidamente em{" "}
        <code>.env.development.local</code>
      </Text>

      <ButtonPrimary onClick={handleRequest} label="Request" />
      <SampleRequestResult as={JsonData} {...{ response, error, loading }} />
    </SectionContent>
  );
};

SampleRequest.propTypes = {};

export default SampleRequest;
